import {
  List,
  Create,
  Edit,
  SimpleForm,
  TextField,
  BooleanField,
  BooleanInput,
  DateField,
  DateInput,
  TextInput,
  Resource,
  Show,
  Datagrid,
  EditButton,
  ReferenceField,
  ReferenceInput,
  SelectInput,
  required,
} from "react-admin";

const BcomeVersionList = (props) => (
  <List {...props} sort={{ field: "createdAt", order: "DESC" }}>
    <Datagrid rowClick="show">
      <TextField source="id" label="ID" />
      <ReferenceField
        label="DB Version"
        source="databaseVersionId"
        reference="databaseVersion"
        link="show"
      >
        <TextField source="name" />
      </ReferenceField>
      <ReferenceField
        label="LCA Version"
        source="lcaMethodologyVersionId"
        reference="lcaMethodologyVersion"
        link="show"
      >
        <TextField source="name" />
      </ReferenceField>
      <ReferenceField
        label="Circularity Version"
        source="circularityVersionId"
        reference="circularityVersion"
        link="show"
        emptyText="—"
      >
        <TextField source="circularity_version_name" />
      </ReferenceField>
      <TextField source="description" label="Description" />
      <BooleanField source="isActive" label="Active" />
      <DateField source="releaseDate" label="Release Date" />
      <EditButton />
    </Datagrid>
  </List>
);

const BcomeVersionShow = (props) => (
  <Show {...props}>
    <SimpleForm>
      <TextField source="id" label="ID" />
      <ReferenceField
        label="DB Version"
        source="databaseVersionId"
        reference="databaseVersion"
        link="show"
      >
        <TextField source="name" />
      </ReferenceField>
      <ReferenceField
        label="LCA Version"
        source="lcaMethodologyVersionId"
        reference="lcaMethodologyVersion"
        link="show"
      >
        <TextField source="name" />
      </ReferenceField>
      <ReferenceField
        label="Circularity Version"
        source="circularityVersionId"
        reference="circularityVersion"
        link="show"
        emptyText="—"
      >
        <TextField source="circularity_version_name" />
      </ReferenceField>
      <TextField source="description" label="Description" />
      <BooleanField source="isActive" label="Active" />
      <DateField source="releaseDate" label="Release Date" />
    </SimpleForm>
  </Show>
);

const BcomeVersionCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
      <ReferenceInput
        label="DB Version"
        source="databaseVersionId"
        reference="databaseVersion"
        validate={required()}
      >
        <SelectInput optionText="name" />
      </ReferenceInput>
      <ReferenceInput
        label="LCA Version"
        source="lcaMethodologyVersionId"
        reference="lcaMethodologyVersion"
        validate={required()}
      >
        <SelectInput optionText="name" />
      </ReferenceInput>
      <ReferenceInput
        label="Circularity Version"
        source="circularityVersionId"
        reference="circularityVersion"
        allowEmpty
      >
        <SelectInput optionText="circularity_version_name" emptyValue={null} />
      </ReferenceInput>
      <TextInput source="description" label="Description" multiline fullWidth />
      <BooleanInput source="isActive" label="Active" />
      <DateInput source="releaseDate" label="Release Date" />
    </SimpleForm>
  </Create>
);

const BcomeVersionEdit = (props) => (
  <Edit {...props}>
    <SimpleForm>
      <TextField source="id" label="ID" />
      <ReferenceInput
        label="DB Version"
        source="databaseVersionId"
        reference="databaseVersion"
        validate={required()}
      >
        <SelectInput optionText="name" />
      </ReferenceInput>
      <ReferenceInput
        label="LCA Version"
        source="lcaMethodologyVersionId"
        reference="lcaMethodologyVersion"
        validate={required()}
      >
        <SelectInput optionText="name" />
      </ReferenceInput>
      <ReferenceInput
        label="Circularity Version"
        source="circularityVersionId"
        reference="circularityVersion"
        allowEmpty
      >
        <SelectInput optionText="circularity_version_name" emptyValue={null} />
      </ReferenceInput>
      <TextInput source="description" label="Description" multiline fullWidth />
      <BooleanInput source="isActive" label="Active" />
      <DateInput source="releaseDate" label="Release Date" />
    </SimpleForm>
  </Edit>
);

const bcomeVersionResource = () => (
  <Resource
    name="bcomeVersion"
    options={{ label: "Version Sets", menuGroup: "Bcome" }}
    list={BcomeVersionList}
    show={BcomeVersionShow}
    create={BcomeVersionCreate}
    edit={BcomeVersionEdit}
  />
);

export default bcomeVersionResource;
